import axios from '../axios';

const sanitizeFilename = (name) => {
  if (!name || typeof name !== 'string') return null;
  return name.replace(/[\\\/:*?"<>|]+/g, '-').trim() || null;
};

const getFilenameFromContentDisposition = (contentDisposition) => {
  if (!contentDisposition || typeof contentDisposition !== 'string') return null;


  const starMatch = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (starMatch?.[1]) {
    try {
      return decodeURIComponent(starMatch[1]).replace(/["']/g, '').trim();
    } catch (_) {
      return starMatch[1].replace(/["']/g, '').trim();
    }
  }

  const quotedMatch = contentDisposition.match(/filename\s*=\s*"([^"]+)"/i);
  if (quotedMatch?.[1]) return quotedMatch[1].trim();

  const plainMatch = contentDisposition.match(/filename\s*=\s*([^;]+)/i);
  if (plainMatch?.[1]) return plainMatch[1].replace(/["']/g, '').trim();

  return null;
};

export const downloadDevices = async (deviceIds, projectId, projectName) => {
    try {
      const response = await axios.post(
        `devices/download-cert`,
        { deviceIds, projectId, projectName },
        { responseType: 'blob' }
      );

      const contentDisposition =
        response?.headers?.['content-disposition'] || response?.headers?.['Content-Disposition'];
      const filenameFromHeader = getFilenameFromContentDisposition(contentDisposition);
      const blob = response.data;

      let filename = sanitizeFilename(filenameFromHeader);
      if (!filename) {
        if (Array.isArray(deviceIds) && deviceIds.length === 1 && blob?.text) {
          try {
            const json = JSON.parse(await blob.text());
            const deveui = json?.payload?.devices?.[0]?.deveui;
            filename = sanitizeFilename(deveui ? `${deveui}.cert` : null);
          } catch (_) {
            // ignore parse errors, fallback below
          }
        }

        if (!filename) {
          const epoch = Math.floor(Date.now() / 1000);
          if (Array.isArray(deviceIds) && deviceIds.length === 1) {
            filename = 'device.cert';
          } else if (projectName) {
            filename = `${projectName} devices ${epoch}.cert`;
          } else {
            filename = `Allorado devices ${epoch}.cert`;
          }
          filename = sanitizeFilename(filename);
        }
      }

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Failed to download devices:', error);
    } 
};